export default [
  {
    path: ':id/tasks',
    component: () => import(/* webpackChunkName: "tasks" */ '@/views/Tasks/pages'),
    children: [
      {
        path: '/',
        name: 'Tasks',
        component: () => import(/* webpackChunkName: "tasks" */ '@/views/Tasks/pages/Tasks'),
      },
      {
        path: 'menu',
        name: 'MenuTasks',
        component: () => import(/* webpackChunkName: "tasks" */ '@/views/Tasks/pages/MenuTasks')
      },
      {
        path: 'register',
        name: 'RegisterTask',
        component: () => import(/* webpackChunkName: "tasks" */ '@/views/Tasks/pages/RegisterTask')
      },
      {
        path: ':idTask/edit',
        name: 'EditTask',
        component: () => import(/* webpackChunkName: "tasks" */ '@/views/Tasks/pages/RegisterTask')
      },
      {
        path: 'register-contents',
        name: 'RegisterContents',
        component: () => import(/* webpackChunkName: "tasks" */ '@/views/Tasks/pages/RegisterContents')
      },
      {
        path: 'list-contents',
        name: 'ListContents',
        component: () => import(/* webpackChunkName: "tasks" */ '@/views/Tasks/pages/ListContents')
      },
      {
        path: 'phrase-diary',
        name: 'PhraseDiary',
        component: () => import(/* webpackChunkName: "tasks" */ '@/views/Tasks/pages/RegisterContents/PhraseDiary')
      },
      {
        path: 'text',
        name: 'Text',
        component: () => import(/* webpackChunkName: "tasks" */ '@/views/Tasks/pages/RegisterContents/Text')
      },
      {
        path: 'challenges',
        name: 'Challenges',
        component: () => import(/* webpackChunkName: "tasks" */ '@/views/Tasks/pages/RegisterContents/Challenges')
      },
      {
        path: 'bonus',
        name: 'Bonus',
        component: () => import(/* webpackChunkName: "tasks" */ '@/views/Tasks/pages/RegisterContents/Bonus')
      },
    ]
  },
]
